// reducers/fileReducers.js

import {
  FETCH_FILES_REQUEST,
  FETCH_FILES_SUCCESS,
  FETCH_FILES_FAIL,
  FILE_DETAILS_REQUEST,
  FILE_DETAILS_SUCCESS,
  FILE_DETAILS_FAIL,
  CREATE_FILE_SUCCESS,
  CREATE_FILE_FAIL,
  UPDATE_FILE_SUCCESS,
  UPDATE_FILE_FAIL,
  DELETE_FILE_SUCCESS,
  DELETE_FILE_FAIL,
  CREATE_FILE_RESET,
  CREATE_FILE_REQUEST,
} from '../constants/fileConstants';

// Reducer to handle fetching all files
export const fileListReducer = (state = { files: [] }, action) => {
  switch (action.type) {
    case FETCH_FILES_REQUEST:
      return { ...state, loading: true }; // Preserve existing files while loading
    case FETCH_FILES_SUCCESS:
      return { loading: false, files: action.payload };
    case FETCH_FILES_FAIL:
      return { loading: false, error: action.payload, files: state.files };
    default:
      return state;
  }
};

// Reducer to handle getting details of a specific file
export const fileDetailsReducer = (state = { file: {} }, action) => {
  switch (action.type) {
    case FILE_DETAILS_REQUEST:
      return { loading: true, ...state };
    case FILE_DETAILS_SUCCESS:
      return { loading: false, file: action.payload };
    case FILE_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reducer to handle file creation
export const fileCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_FILE_REQUEST:
      return { loading: true };
    case CREATE_FILE_SUCCESS:
      return { success: true, file: action.payload };
    case CREATE_FILE_FAIL:
      return { error: action.payload };
    case CREATE_FILE_RESET:
      return {};
    default:
      return state;
  }
};

// Reducer to handle file update
export const fileUpdateReducer = (state = { file: {} }, action) => {
  switch (action.type) {
    case UPDATE_FILE_SUCCESS:
      return { success: true, file: action.payload };
    case UPDATE_FILE_FAIL:
      return { error: action.payload };
    default:
      return state;
  }
};

// Reducer to handle file deletion
export const fileDeleteReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_FILE_SUCCESS:
      return { success: true };
    case DELETE_FILE_FAIL:
      return { error: action.payload };
    default:
      return state;
  }
};
